export enum BillingInterval {
  ANNUAL = 'Annually',
  MONTHLY = 'Monthly',
  QUARTERLY = 'Quarterly',
  UNKNOWN = '',
}

export type PlanEntity = {
  pausable: boolean | null;
  isTrial: boolean | null;
  id: number | null;
  custom: boolean | null;
  name: string | null;
  type: PlanType | null;
  canSelfDowngrade: boolean | null;
  isSwitchingToTeamPlanADowngrade: boolean | null;
  seats_taken: number | null;
  seatsTotal: number | null;
  isTrialExpired: boolean | null;
  tier: PlanTier;
  billingInterval: BillingInterval;
  pricePerSeatPerInterval: number;
  estimatedRenewalTotal: number;
  price: number;
  trialDaysRemaining: number | null;
  isLegacyPlan: boolean;
};

export type PlanApiResponse = {
  archive: boolean;
  code: string;
  custom: boolean;
  id: number;
  is_trial: boolean;
  name: string;
  pausable: boolean;
  plan_type_id: number | null;
  type: PlanType;
  can_self_downgrade: boolean;
  isSwitchingToTeamPlanADowngrade: boolean;
  seats_taken: number | null;
  total_seats: number | null;
  is_trial_expired: boolean;
  billing_interval_length: number | null;
  estimated_renewal_total: number;
  price: number;
  trial_days_remaining: number | null;
  is_legacy_plan: boolean;
};

export type UpdatePlanApiResponse = {
  status: string;
  message: string;
  action_link?: string;
};

export type UpdatePlanPayload = {
  promoCode?: string;
  planId: number;
  paidSeats: number;
};

export type UpdatePlanParam = {
  accountId: number;
  payload: UpdatePlanPayload;
};

export type ApplyPromoCodeApiResponse = {
  status: string;
  message: string;
};

export type CancelPlanApiResponse = {
  state: string;
  message: string;
};

export type CancelReasonPayload = {
  id: number;
  reasonDescription: string;
  canContact: boolean;
  comment: string;
};

export type CancelPlanPayload = {
  accountId: number;
  cancelReasonPayload: CancelReasonPayload;
};

export type PlanTier = 'free' | 'basic' | 'team' | 'grande' | 'business' | '' | 'employee';
export type PlanType = 'business' | 'team' | 'custom' | 'basic' | '';
